/**
 * Created by USER on 18/4/24.
 */
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import {Icon, message} from 'antd';
import ImageList from '../images/img';
import httpClient from '../swagger/swagger';

const {client} = httpClient;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWechatQrCode: 'none',
      appName: null, // 区分不同的app时不同的路由跳转方式
      popUpNoticeIsShow: 'none',
      popUpNoticeData: {
        id: null,
        category_name: "",
        sub_title: "",
        title: "",
      }
    };
  }

  componentDidMount() {
    this.getNotice()
    this.setState({
      appName: window.appName,
    });
  }

  getNotice() { // 获取弹出的公告
    client.then((oclient) => {
      oclient.apis.bulletin.get_bulletins_language({
        language: this.props.t('language'),
        limit: 1,
        page: 1,
        category_id: 2
      }).then((res) => {
        const data = res.obj;
        if (data.code === 200) {
          if (data.data.length > 0) {
            this.setState({
              popUpNoticeData: data.data[0]
            });
            // 判断是否与cookie有相同的 来判断是否弹出公告
            const cookieNoticeId = this.getCookie('noticeId');
            if (!cookieNoticeId || Number(cookieNoticeId) !== data.data[0].id) {
              this.setState({
                popUpNoticeIsShow: 'block'
              });
              document.cookie = `noticeId=${data.data[0].id}; domain=lubanso.com;`;
            }
          }
        } else {
          message.error(data.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return false;
  }

  closePopNotice() { // 关闭公告的弹窗
    this.setState({
      popUpNoticeIsShow: 'none'
    })
  }

  showQrCode() { // 二维码显示
    this.setState({
      showWechatQrCode: 'block'
    });
  }

  hideQrCode() { // 二维码隐藏
    this.setState({
      showWechatQrCode: 'none'
    });
  }

  clickWechatIcon() { // 鼠标点击微信二维码
    if (this.state.showWechatQrCode === 'none') {
      this.setState({
        showWechatQrCode: 'block'
      });
    }
  }

  goToWeibo() { // 打开公司微博
    window.open('https://weibo.com/6543415870/profile?rightmod=1&wvr=6&mod=personinfo&is_all=1');
  }

  goToTelegram() { // 打开公司Telegram
    window.open('https://t.me/lubanso');
  }

  scorllTop() { // 滚动到顶部
    window.scroll(0, 0);
  }

  backTop() { // 回到顶部
    window.scrollBy(0, -100);
    const scrolldelay = setInterval(() => {
      window.scrollBy(0, -100);
      const sTop = document.documentElement.scrollTop + document.body.scrollTop;
      if (sTop === 0 || sTop === -100) clearInterval(scrolldelay);
    }, 10);
  }

  routerWay(route) { // 不同域名下的不同跳转的方式
    if (window.appName === 'blog') {
      window.event ? window.event.cancelBubble = true : event.stopPropagation();
      window.location.href = `https://www.lubanso.com/${route}`
    }
  }

  render() {
    const {t} = this.props;
    const {appName, popUpNoticeIsShow, popUpNoticeData} = this.state;
    const {offsetWidth} = this.props.appBarReducer;
    return (
      <div className="footer">
        <div className="pop_up_notice" style={{display: popUpNoticeIsShow}}>
          <div className="pop_up_notice_background"/>
          <div className="pop_up_notice_content">
            <div>
              <Icon type="close" onClick={() => this.closePopNotice()}/>
            </div>
            <img src={ImageList.img.popUpNotice} alt="lubanso"/>
            <h3>{popUpNoticeData.sub_title}</h3>
            <p>{popUpNoticeData.title}</p>
            {
              appName !== 'blog' ?
                <Link
                  to={`/${(offsetWidth && offsetWidth > 768) ? 'announcement' : 'announcement_detail'}?Notice_id=${popUpNoticeData.id}`}
                  onClick={() => this.closePopNotice()}>
                  <span>{t('viewMore')}</span>
                </Link> :
                <a
                  href={`https://www.lubanso.com/${(offsetWidth && offsetWidth > 768) ? 'announcement' : 'announcement_detail'}?Notice_id=${popUpNoticeData.id}`}>
                  <span>{t('viewMore')}</span>
                </a>
            }
          </div>
        </div>
        {/*<div*/}
        {/*className="back_top"*/}
        {/*title="回到顶部"*/}
        {/*onClick={() => this.backTop()}*/}
        {/*onKeyPress={() => this.backTop()}*/}
        {/*>*/}
        {/*<Icon type="arrow-up" />*/}
        {/*</div>*/}
        <div className="footer_content">
          <div className="company_content">
            <div className="footer_content_title">
              <span className="icon iconfont icon-lubanso"/>
              <i className="footer_logo_name icon iconfont icon-english"/>
            </div>
            {/* <div className="footer_content_details">
              <a href="tel:4008-560-890">
                <span>{t('footer_tel')}</span> 4008-560-890
              </a>
            </div> */}
            <div className="footer_content_details">
              <a href="mailto:support@lubanso.com">
                <span>{t('footer_email')}</span> support@lubanso.com
              </a>
            </div>
            <div className="footer_content_divider"/>
            <div className="footer_content_details">
              <a href="mailto:media@lubanso.com">
                <span>{t('footer_media')}</span> media@lubanso.com
              </a>
            </div>
            <div className="footer_content_details">
              <a href="mailto:business@lubanso.com">
                <span>{t('footer_business')}</span> business@lubanso.com
              </a>
            </div>
          </div>
          <div className="product_content">
            <div className="footer_content_title">{t('footer_product')}</div>
            {
              appName !== 'blog' ?
                <Link to="/X1">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('X1')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('X1')
                    }}
                  >LUBANSO X1
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/X1">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('X1')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('X1')
                    }}
                  >LUBANSO X1
                  </div>
                </a>
            }
            {/* {
              appName !== 'blog' ?
                <Link to="/download">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('download')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('download')
                    }}
                  >{t('head_download')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/download">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('download')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('download')
                    }}
                  >{t('head_download')}
                  </div>
                </a>
            } */}
            {/* {
              appName !== 'blog' ?
                <Link to="/affiliates">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('affiliates')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('affiliates')
                    }}
                  >
                    {t('head_affiliate')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/affiliates">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('affiliates')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('affiliates')
                    }}
                  >
                    {t('head_affiliate')}
                  </div>
                </a>
            } */}
          </div>
          <div className="support_content">
            <div className="footer_content_title">{t('footer_service_support')}</div>
            {
              appName !== 'blog' ?
                <Link to={{pathname: '/about', state: 'agreement'}}>
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  > {t('footer_agreement')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/about">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  > {t('footer_agreement')}
                  </div>
                </a>
            }
            {
              appName !== 'blog' ?
                <Link to={{pathname: '/about', state: 'afterSales'}}>
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  > {t('footer_after_sale')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/about">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  > {t('footer_after_sale')}
                  </div>
                </a>
            }
          </div>
          <div className="about_us_content">
            <div className="footer_content_title">{t('footer_about_us')}</div>
            {
              appName !== 'blog' ?
                <Link to={{pathname: '/about', state: 'aboutLUBANSO'}}>
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  >LUBANSO
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/about">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('about')
                    }}
                  >LUBANSO
                  </div>
                </a>
            }
            {
              appName !== 'blog' ?
                <Link to={{pathname: '/team', state: 'LUBANSO_team'}}>
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                  >{t('footer_team')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/team">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                  >{t('footer_team')}
                  </div>
                </a>
            }
            {
              appName !== 'blog' ?
                <Link to={{pathname: '/team', state: 'LUBANSO_laboratory'}}>
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                  >{t('footer_laboratory')}
                  </div>
                </Link> :
                <a href="https://www.lubanso.com/team">
                  <div
                    className="footer_content_details"
                    onClick={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                    onKeyPress={() => {
                      this.scorllTop();
                      this.routerWay('team')
                    }}
                  >{t('footer_laboratory')}
                  </div>
                </a>
            }
          </div>
        </div>
        <div className="contact_us_title">{t('footer_contact')}</div>
        <div className="contact_us">
          <span
            className="icon iconfont icon-weibo"
            onClick={() => this.goToWeibo()}
            onKeyPress={() => this.goToWeibo()}
          />
          <span
            className="icon iconfont icon-wechat"
            onMouseOver={() => this.showQrCode()}
            onMouseOut={() => this.hideQrCode()}
            onClick={() => this.clickWechatIcon()}
            onKeyPress={() => this.clickWechatIcon()}
          >
            <div
              className="img_qrocde"
              style={{display: this.state.showWechatQrCode}}
            >
              <img src={ImageList.img.wechatQrCode} alt="LUBANSO"/>
            </div>
          </span>
          <span
            className="icon iconfont icon-telegram"
            onClick={() => this.goToTelegram()}
            onKeyPress={() => this.goToTelegram()}
          />
        </div>
        <div className="company_tag">
          <span style={{display: 'inline-block'}}>
            {t('footer_company', {now: moment(new Date()).format('YYYY')  })}
            <a href="http://www.beian.miit.gov.cn" target={'_blank'}>
            {t('footer_company1')}
            </a>

              <div style={{display: 'inline-block'}}>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33019902000258"
               style={{display: 'inline-block', textDecoration: 'none'}}>
              <img
                src="https://lubansohz.oss-cn-hangzhou.aliyuncs.com/lubanso-web/images/2020-01-02/83818ec58aff4f1383c4024e93049623.png"
                style={{display: 'inline-block'}}/><p
              style={{display: 'inline-block',margin: '0px 0px 0px 2px', color: '#939393'}}>
              浙公网安备 33019902000258号</p></a>
          </div>
          </span>


        </div>
      </div>
    );
  }
}

// {/*<Link to={{pathname: '/about_LUBANSO', state: 'team'}}>*/}
// {/*<div*/}
// {/*className="footer_content_details"*/}
// {/*onClick={() => this.scorllTop()}*/}
// {/*onKeyPress={() => this.scorllTop()}*/}
// {/*>团队*/}
// {/*</div>*/}
// {/*</Link>*/}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const FooterConnected = connect(select)(Footer);

export default translate('translations')(FooterConnected);

